<script lang="ts">
    import type ServiceProvider from '../services/service.provider'
    import type { Action } from '../interfaces/interfaces'
    import { formatDateTimeRange } from '../../../core/utils/date.util'
    import Pager from './Pager.svelte'

    export let serviceProvider: ServiceProvider

    let actionList: Action[] = []
    let total = 0
    let error = false
    let processing = false
    let isFilterActive = false

    serviceProvider.searchService.listSubs.subscribe((list) => {
        actionList = list
        window.scrollTo({ top: 0, behavior: "smooth" })
    })
    serviceProvider.searchService.totalSubs.subscribe((number) => (total = number))
    serviceProvider.searchService.errorSubs.subscribe((status) => (error = status))
    serviceProvider.searchService.processingSubs.subscribe((status) => (processing = status))
    serviceProvider.searchService.isFilterActiveSubs.subscribe((isActive) => (isFilterActive = isActive))

    let portalUrl = window.location.origin;

    if (window.location.hostname === "localhost") {
        portalUrl = "https://smb-web-dev.asseco-ce.com";
    }

    const imgW = "530"; // maximum img width on some viewport size
</script>

{#if processing}
    <h2>Vyhledávám...</h2>
{:else if error}
    <h2>Výsledky vyhledávání</h2>
    <p>Nastala chyba při vyhledávání</p>
{:else}
    {#if isFilterActive}
        <h2>Vyhledané akce</h2>
    {:else}
        <h2>Nejbližší akce</h2>
    {/if}

    {#if Array.isArray(actionList) && actionList.length}
        <ul class="bno-grid bno-grid--x3 bno-list--plain">
            {#each actionList as item}
                <li class="bno-grid__tile">
                    <div class="bno-preview-tile {item.prehledovaFotografie ? 'bno-preview-tile--visual' : ''}">
                        <div class="bno-preview-tile__header {!item.prehledovaFotografie ? 'bno-preview-tile__header--plain' : ''}">
                            {#if item.prehledovaFotografie}
                                <img
                                    src="{portalUrl}/picfit/display?url={portalUrl}{item.prehledovaFotografie}&w={imgW}&op=resize"
                                    alt=""
                                />
                            {/if}
                            <div class="bno-preview-tile__bar">
                                <span class="bno-chip bno-chip--primary bno-chip--x-large bno-chip--inline">
                                    <span class="bno-chip__inner">
                                        {formatDateTimeRange(item.datumOd, item.datumDo, item.casOd, item.casDo)}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="bno-preview-tile__content">
                            <h3>
                                <a href={item.url} aria-label={item.title}>
                                    {item.title}
                                </a>
                            </h3>
                            {#if !item.prehledovaFotografie && item.kratkyPopis}
                                <p class="bno-note">
                                    {item.kratkyPopis}
                                </p>
                            {/if}
                            {#if item.nazevMista}
                                <a class="bno-link bno-link--linkless" href={item.url} aria-label={item.nazevMista}>
                                    <span class="bno-icon bno-icon--pin" aria-hidden="true"></span>{item.nazevMista}
                                </a>
                            {/if}
                        </div>
                    </div>
                </li>
            {/each}
        </ul>
        {#if !processing && total > 6}
            <!-- TODO: klasicke strankovani nahradit za btn "Více akcí a událostí" -->
            <Pager {serviceProvider}/>
        {/if}
    {:else}
        <p>Vašemu zadání neodpovídají žádné výsledky</p>
    {/if}
{/if}
